export default __webpack_public_path__ + "static/media/section2.2936fc02.png";